import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, shareReplay, switchMap } from 'rxjs/operators';

import { AuthService } from './auth.service';

let refreshTokenRequest$: null | Observable<any> = null;

function addToken(request: HttpRequest<any>, token: string) {
  return request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
}

function handle401Error(
  request: HttpRequest<any>,
  next: HttpHandlerFn,
  authService: AuthService,
): Observable<any> {
  if (!refreshTokenRequest$) {
    refreshTokenRequest$ = authService.refreshAccessToken().pipe(
      shareReplay(1),
      finalize(() => (refreshTokenRequest$ = null)),
    );
  }

  return refreshTokenRequest$.pipe(
    switchMap((tokens: { accessToken: string }) => {
      return next(addToken(request, tokens.accessToken));
    }),
    catchError((err) => {
      authService.logout();
      return throwError(() => err);
    }),
  );
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const accessToken = authService.accessToken;

  if (accessToken && !req.url.includes('/auth/refresh')) {
    req = addToken(req, accessToken);
  }

  return next(req).pipe(
    catchError((error) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        !req.url.includes('/auth/refresh')
      ) {
        return handle401Error(req, next, authService);
      }
      return throwError(() => error);
    }),
  );
};
